import { faMagic, faImage, faVideo, faFileText } from '@fortawesome/free-solid-svg-icons';
import { QuestionOption } from '../types';

export const getStartTypeOptions = (outputType: string): QuestionOption[] => {
  const baseOptions = [
    { id: 'scratch', label: 'From scratch', icon: faMagic, value: 'Create from my own idea' },
    { id: 'continue-image', label: 'Continue from image', icon: faImage, value: 'Build next scene from reference image' },
    { id: 'continue-video', label: 'Continue from video', icon: faVideo, value: 'Build next scene from reference video' },
    { id: 'script', label: 'Import script', icon: faFileText, value: 'Based on written dialogue/narrative' }
  ];

  // All output types use the same options now
  // Users upload media via the "+" button when they select continue options
  return baseOptions;
};
